import { render, staticRenderFns } from "./RevisionPagination.vue?vue&type=template&id=2bbcc04a&"
import script from "./RevisionPagination.vue?vue&type=script&lang=js&"
export * from "./RevisionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports